import moment from "moment";
import _ from "lodash";
import DiaryListServices from "@/services/DiaryListServices";
import NavBarTop from "@/components/shared/NavBarTop";
import ConfirmModal from "@/components/shared/ConfirmModal";
import CopyDiaryModal from "@/components/DiaryList/CopyDiaryModal";
import { putCo2Input } from "@/api/SiteApi";
import { putMetaDataSite, generateKyExcel, getSiteUserMe } from "@/api/SiteApi";
import {
  // compareDiaryDateDesc,
  isRevisionLastestStateCo2Complete,
  validateYear,
  validateMonth,
  validateValue,
  validateJPY,
  configDatePick,
  isInt,
  isFloat,
} from "@/services/GlobalServices";
import MessModal from "@/components/shared/MessModal";
import ConfirmCopyDiaryModal from "@/components/shared/ConfirmCopyDiaryModal";
import TemplateTooltip from "@/components/shared/TemplateTooltip";
import DiaryListInternalData from "@/internalData/DiaryList";
import DiaryListConstants from "@/store/constants/diaryListRecords";
import MetaDataSite from "@/components/DiaryList/MetaDataSite";
import TrashIcon from "@/components/shared/TrashIcon";
import MetaDataInternalData from "@/internalData/MetaData";
import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardInternalConstant from "@/internalData/Dashboard";
import Co2Items from "@/internalData/Co2Items";
import Co2ModalHelper from "@/helper/dashboard/co2ModalHelper";
import GlobalConstants from "@/store/constants/global";
import { validateMetaData } from "@/services/GlobalServices";
import DashboardServices from "@/services/DashboardServices";
import ShowRevisionServices from "@/services/ShowRevisionServices";
import { postDiaryApi } from "@/api/DiaryApi";
import contractorAuthApi from "@/api/ContractorAuthApi";
export default {
  name: "DiaryList",
  components: {
    NavBarTop,
    ConfirmModal,
    CopyDiaryModal,
    MessModal,
    ConfirmCopyDiaryModal,
    TemplateTooltip,
    MetaDataSite,
    TrashIcon,
  },
  data() {
    return {
      calendarJustOpened: false,
      period: "",
      meta: {
        states: [
          {
            key: "beforeMeeting",
            value: this.$t("diaryList.state.beforeMeeting"),
          },
          {
            key: "completedMeeting",
            value: this.$t("diaryList.state.completedMeeting"),
          },
          {
            key: "inputCo2Values",
            value: this.$t("diaryList.state.inputCo2Values"),
          },
        ],
      },
      periodFields: [
        { key: "daytime", value: this.$t("diaryList.periods.daytime") },
        { key: "nighttime", value: this.$t("diaryList.periods.nighttime") },
      ],
      dataTimePickerOptions: Object.assign(configDatePick("LL", true), {
        showClear: false,
        showClose: false,
      }),
      diarySites: [],
      //use to delete class name highlight date in calendar
      diaryEditingPrevious: [],
      diaryEditingCurrent: [],
      //use checking editing diary link is clicked, handle period default
      diariesEditingLinkIsClicked: false,
      electricityMenus: DiaryListInternalData.electricityMenus,
      waterIntakeMenus: DiaryListInternalData.waterIntakeMenus,
      drainageDestinationMenus: DiaryListInternalData.drainageDestinationMenus,
      leftTurnOffLight: DiaryListInternalData.leftTurnOffLight,
      alterNativeFuel: DiaryListInternalData.alterNativeFuel,
      alterNativeEnergy: DiaryListInternalData.alterNativeEnergy,
      utilizationOfElectricityMenus:
        DiaryListInternalData.utilizationOfElectricityMenus,
      leftHigtEffiencyLumi: DiaryListInternalData.leftHigtEffiencyLumi,
      middleOfficeTemperature: DiaryListInternalData.middleOfficeTemperature,
      middleAirCondition: DiaryListInternalData.middleAirCondition,
      middleFuelSaving: DiaryListInternalData.middleFuelSaving,
      middleEngineStop: DiaryListInternalData.middleEngineStop,
      middleInspectionMainternace:
        DiaryListInternalData.middleInspectionMainternace,
      middleGuideFuelSaving: DiaryListInternalData.middleGuideFuelSaving,
      tooltipMess: DiaryListInternalData.tooltipMess,
      deletingObjectAmount: {
        attr: "",
        index: -1,
        subAttr: "",
      },
      kendoTypeFields: MetaDataInternalData.kendoTypeFields,
      isArchitecture: true,
      machineTypeOption: DashboardInternalConstant.co2Modal.machineTypeOption,
      inSiteWorkFields: DashboardInternalConstant.co2Modal.inSiteWorkFields,
      diaryInSiteWorkFields:
        DashboardInternalConstant.co2Modal.diaryInSiteWorkFields,
      outSiteWorkFields: DashboardInternalConstant.co2Modal.outSiteWorkFields,
      outSiteWorkWasteFields:
        DashboardInternalConstant.co2Modal.outSiteWorkWasteFields,
      outSiteWorkContructionSoilFields:
        DashboardInternalConstant.co2Modal.outSiteWorkContructionSoilFields,
      loadCapacityRecords:
        DashboardInternalConstant.co2Modal.loadCapacityRecords,
      dataTimePickerOptionsCO2: configDatePick("LT"),
      showEditorError: false,
      statusSaveDiary: false,
      isPostedDiary: false,
      isCO2InputChanged: false,
      meetingDateDateTimePickerOptions: configDatePick("LL", false),
      isUseDiary: true,
      siteUserRole: null,
    };
  },
  created() {
    this.refreshDataByURL();
    
    // 契約社員認証状態変化のイベントリスナー
    this.$root.$on('contractor-auth-changed', (data) => {
      if (data.isAuthenticated) {
        console.log('契約社員認証完了 - データ取得を開始');
        this.initializeDataAfterAuth();
      }
    });
    
    // 契約社員として既に認証済みかチェック
    this.checkContractorAuthAndInitialize();
  },
  updated() {
    DiaryListServices.showDateHighLight(
      this.diaryEditingPrevious,
      this.diaryEditingCurrent
    );
  },
  mounted() {
    this.handleDoubleClickActiveDay();
    this.$root.$on("bv::modal::hide", (bvEvent) => {
      if (bvEvent.componentId == "copy-diary-modal") {
        const siteId = this.$route.query.siteId;
        const objDate = this.$route.query.objDate;
        const period = this.$route.query.period;
        if (
          siteId != undefined &&
          period != undefined &&
          objDate != undefined
        ) {
          //set siteSelected, dateChoose, period
          this.$store.commit(DiaryListConstants.COMMIT.setSiteSelected, {
            site: siteId,
          });
          const objDateTemp = moment.unix(objDate);
          this.$store.commit(DiaryListConstants.COMMIT.setCalendarDate, {
            date: objDateTemp,
          });
          this.period = period;
          //fetch data
          //get editing diary
          this.getDiaryEditing();
          //get diary detail
          this.getDiaryDetailData();
        }
      }
    });
    
    // コピー成功時のイベントリスナー
    this.$root.$on('copy-diary-success', (data) => {
      console.log("📅 DiaryList: copy-diary-successイベント受信");
      console.log("📅 受信データ:", data);
      console.log("📅 現在のperiod:", this.period);
      console.log("📅 現在のdateChoose:", this.dateChoose?.format("YYYY-MM-DD"));
      
      // コピー先の日付を作業実施日に設定
      if (data.date) {
        this.dateChoose = data.date;
        console.log("📅 作業実施日を更新:", data.date.format("YYYY-MM-DD"));
      }
      
      // コピー先のperiodを設定
      if (data.period) {
        this.period = data.period;
        console.log("📅 期間を更新:", data.period);
      }
      
      // データを再取得（コピー先の日付とperiodで）
      this.getDiaryEditing();
      this.getDiaryDetailData();
      
      console.log("📅 DiaryList: コピー完了後の処理終了");
    });
    
    const siteId = this.$route.query.siteId || this.siteSelected;
    if (siteId) {
      this.getSiteUserRole(siteId);
    }
  },
  computed: {
    diaries() {
      return this.$store.getters[DiaryListConstants.GETTERS.getDiariesEditing];
    },
    //ignore diary has state inputCo2Values
    editingDairy() {
      const diariesTemp =
        this.$store.getters[DiaryListConstants.GETTERS.getDiariesEditing];
      let diaryEditingSwap = [];
      let diaryEditingResult = [];
      diariesTemp.forEach((element) => {
        const isCo2Complete = isRevisionLastestStateCo2Complete(
          diariesTemp,
          element.diaryDate,
          element.diaryPeriod
        );
        if (!isCo2Complete) {
          diaryEditingSwap.push(element);
        }
      });

      // カスタムソート関数を使用して、日付で降順、同じ日付の場合はdiaryPeriodで昇順（daytimeが先）にソート
      diaryEditingSwap.sort((a, b) => {
        const dateA = moment(a.diaryDate).unix();
        const dateB = moment(b.diaryDate).unix();
        if (dateB !== dateA) {
          return dateB - dateA; // 日付で降順
        }
        // 同じ日付の場合、diaryPeriodで昇順（daytimeが先）
        if (a.diaryPeriod === "daytime" && b.diaryPeriod === "nighttime") {
          return -1; // daytimeが先
        } else if (
          a.diaryPeriod === "nighttime" &&
          b.diaryPeriod === "daytime"
        ) {
          return 1; // daytimeが先
        }
        // 同じdiaryPeriodの場合、revisionで降順
        return b.revision - a.revision;
      });

      // remove duplicate
      const diaryLen = diaryEditingSwap.length;
      for (let i = 0; i < diaryLen; i++) {
        let diary = diaryEditingSwap[i];
        if (!this.checkDiaryPresent(diaryEditingResult, diary)) {
          diaryEditingResult.push(diary);
        }
      }
      return diaryEditingResult;
    },
    sites: function () {
      return this.$store.getters[DiaryListConstants.GETTERS.getSites];
    },
    totalSites: function () {
      return this.$store.getters[DiaryListConstants.GETTERS.getTotalSites];
    },
    siteSelected: {
      get: function () {
        return this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
      },
      set: function (site) {
        this.$store.commit(DiaryListConstants.COMMIT.setSiteSelected, {
          site: site,
        });
        this.handleClickPeriod("daytime");
        this.getSiteUserRole(site);
      },
    },
    dateChoose: {
      get: function () {
        return this.$store.getters[DiaryListConstants.GETTERS.getCalendarDate];
      },
      set: function (date) {
        let currentCalendarChoose = moment(date, "YYYY-MM-DD").locale("en");
        this.$store.commit(DiaryListConstants.COMMIT.setCalendarDate, {
          date: currentCalendarChoose,
        });
      },
    },
    diaryRevisions() {
      return this.$store.getters[DiaryListConstants.GETTERS.getDiaries];
    },
    isValidDiaryRevision() {
      const diaries = this.diaryRevisions;
      return diaries ? diaries.length > 0 : false;
    },
    metaDataLinkDashboard() {
      let siteId = this.siteSelected;
      let dateTimestamp = this.dateChoose.unix();
      let period = this.period;
      return `&siteId=${siteId}&objDate=${dateTimestamp}&period=${period}`;
    },
    getCo2InputElectricity() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.electricity ?? {};
    },
    getCo2InputElectricityMenus() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.electricity.utilizationOfElectricityMenus ?? {};
    },
    getCo2InputCementAlternative() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.others.useOfCementAlternative.monthlyUses ?? [];
    },
    getCo2InputWater() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.water ? co2Input.water : {};
    },
    getCo2InputKerosene() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.kerosene ? co2Input.kerosene : {};
    },
    getCo2InputDiesel() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      if (co2Input.diesel) {
        return co2Input.diesel;
      }
      return {};
    },
    getCo2InputHeavyOil() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.heavyOil ? co2Input.heavyOil : {};
    },
    getCo2InputOrders() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      if (co2Input.others) {
        return co2Input.others;
      }
      const Co2InputOrder = {
        useOfB5: {
          amount: {},
        },
        useOfB100: {
          amount: {},
        },
        useGTLFuel: {
          amount: {},
        },
        installSolarPanelsOnSite: {
          amount: {},
        },
        installWindPowerGenerationOnSite: {
          usage: {},
        },
        useOfRenewableEnergy: "",
        useOfCementAlternative: {
          usage: {},
          monthlyUses: [],
        },
      };
      return Co2InputOrder;
    },
    getCo2InputAlterNativeFuel() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.othersMonthlyUses?.alterNativeFuel ?? [];
    },
    getCo2InputAlterNativeEnergy() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.othersMonthlyUses?.alterNativeEnergy ?? [];
    },
    getCo2InputElectricAmount() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      return co2Input.electricity?.amount ?? [];
    },
    disableInputDiary() {
      const siteSelected =
        this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
      return siteSelected == "" || siteSelected == null;
    },
    // 実施入力で保存済みの場合は予定入力ボタンを非表示にする
    hasActualRevision() {
      const diaries = this.diaryRevisions;
      if (!diaries || diaries.length === 0) return false;
      return diaries.some((revision) => revision.editAs === "actual");
    },
    disableEditBudgetActual() {
      const period = this.period;
      const dataChoose = this.dateChoose;
      return period == undefined || period == "" || dataChoose == null;
    },
    disableSiteSpin() {
      return this.totalSites == null;
    },
    disableCopyIcon() {
      const latestDiaryId =
        this.$store.getters[DiaryListConstants.GETTERS.getDiaryIdLatest];
      return latestDiaryId != -1;
    },
    statusCopyFunction() {
      return this.$store.getters[
        DiaryListConstants.GETTERS.getStateCopyFunction
      ];
    },
    linkBackButtonFromCopyFunction() {
      const latestDiary =
        this.$store.getters[DiaryListConstants.GETTERS.getDiaryLatest];
      const siteId = latestDiary.siteId;
      const objDateTemp = moment(latestDiary.diaryDate).unix();
      const period = latestDiary.diaryPeriod;
      const defaultURL = "/";

      const previousURL = `/?siteId=${siteId}&period=${period}&objDate=${objDateTemp}`;
      return siteId && objDateTemp && period ? previousURL : defaultURL;
    },
    generateParamsAfterCopy() {
      const latestDiary =
        this.$store.getters[DiaryListConstants.GETTERS.getDiaryLatest];
      const siteId = latestDiary.siteId;
      const objDateTemp = moment(latestDiary.diaryDate).unix();
      const period = latestDiary.diaryPeriod;
      return {
        siteId: siteId,
        objDate: objDateTemp,
        period: period,
      };
    },
    kendoSelected() {
      const kendoType =
        this.$store.getters[DiaryListConstants.GETTERS.getMetaDataSite]?.[
          "kendoType"
        ];
      this.metaData.kendoType = kendoType;
      if (!kendoType) {
        this.metaData.kendoType = "civilEngineering";
        this.metaData.kohshuType = "tunnel";
      }
      return kendoType ?? "civilEngineering";
    },
    co2AlterNativeFuel() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        .alterNativeFuel;
    },
    co2InSiteWork() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        .co2InSiteWork;
    },
    co2OutSiteWork() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        .co2OutSiteWork;
    },
    co2OutSiteWorkWaste() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        .co2OutSiteWorkWaste;
    },
    co2OutSiteWorkContructionSoil() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]
        .co2OutSiteWorkContructionSoil;
    },
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    firstMachineLayer() {
      let co2ItemArr = Co2Items.DATA_AFTER_CONVERT;
      return co2ItemArr;
    },
    workPeriod() {
      const sites = this.$store.getters[DiaryListConstants.GETTERS.getSites];
      const site = this.$_.find(sites, (site) => {
        return site.id == this.siteSelected;
      });
      return sites && site ? site.workPeriod : { startDate: "", endDate: "" };
    },
    getDataHeader() {
      return this.$store.getters[DashboardConstants.GETTERS.getDataHeader];
    },
    oldMachineLayers() {
      return DiaryListInternalData.oldMachines;
    },
    metaData() {
      return this.$store.getters[DiaryListConstants.GETTERS.getMetaDataSite];
    },
    useDiary() {
      this.isUseDiary = true;
      return true;
    },
    utilizationOfElectricityMenusDefault() {
      return DiaryListInternalData.utilizationOfElectricityMenus[0].value;
    },
    isViewerUser() {
      return this.siteUserRole === 'VIEWER';
    },
    isLoadingCalendar() {
      return this.$store.getters[DiaryListConstants.GETTERS.getIsLoadingDiaryEditing];
    },
  },
  methods: {
    getSiteUserRole(siteId) {
      if (siteId) {
        getSiteUserMe(siteId).then(response => {
          this.siteUserRole = response.data.role;
        }).catch(error => {
          console.error('Failed to get site user role:', error);
        });
      }
    },
    isKendoTypeArchitecture() {
      const kendoType = this.metaData.kendoType;
      return kendoType == "architecture";
    },
    setMetaDataState(attr, value) {
      if (attr === "kendoType") {
        this.isArchitecture = value === "architecture";
      }
      if (value === "civilEngineering") {
        this.metaData.kohshuType = "tunnel";
      } else if (value === "architecture") {
        this.metaData.kohshuType = "theOffice";
      }
      this.$store.commit(DiaryListConstants.COMMIT.updateMetaDataSite, {
        attr,
        value,
      });
      setTimeout(() => {
        if (!this.errors.all().length) {
          this.updateMetaData(attr);
        }
      }, 300);
    },
    updateMetaData(attr) {
      if (attr === "use_diary" || attr === "kendoType") {
        let kendoType = this.metaData.kendoType;
        if (!kendoType) {
          kendoType = "civilEngineering";
          this.metaData.kendoType = kendoType;
        }
        if (kendoType === "civilEngineering") {
          this.metaData.architecture = "civilEngineering";
        } else if (kendoType === "architecture") {
          this.metaData.architecture = "RCConstruction";
        }
      }
      if (this.siteSelected && validateMetaData(this.metaData)) {
        const metaData = Object.assign({}, this.metaData, {
          workPeriod: {
            endDate: this.workPeriod.endDate,
            startDate: this.workPeriod.startDate,
          },
        });
        putMetaDataSite(this.siteSelected, metaData);
      }
    },
    goToSiteDailyWorkRecord() {
      if (this.siteSelected && this.dateChoose) {
        this.$router.push({
          path: '/site-daily-work-record',
          query: { siteId: this.siteSelected, objDate: this.dateChoose.unix(), period: this.period }
        });
      }
    },
    goToSiteSafetyHealthMeasures() {
      if (this.siteSelected && this.dateChoose) {
        this.$router.push({
          path: '/site-safety-health-measures',
          query: { siteId: this.siteSelected, objDate: this.dateChoose.unix(), period: this.period }
        });
      }
    },
    goToSiteWorkMonthlyResults() {
      if (this.siteSelected && this.dateChoose) {
        this.$router.push({
          path: '/site-work-monthly-results',
          query: { siteId: this.siteSelected, objDate: this.dateChoose.unix(), period: this.period }
        });
      }
    },
    async refreshDataByURL() {
      const siteId = this.$route.query.siteId;
      const objDate = this.$route.query.objDate;
      const period = this.$route.query.period;
      if (siteId != undefined && period != undefined && objDate != undefined) {
        console.log('refreshDataByURL: URLパラメータでサイト情報を設定中...', { siteId, objDate, period });
        
        // まずサイト一覧を取得
        await this.$store.dispatch(DiaryListConstants.DISPATCH.getSiteRecords);
        
        //set siteSelected, dateChoose, period
        this.$store.commit(DiaryListConstants.COMMIT.setSiteSelected, {
          site: siteId,
        });
        const objDateTemp = moment.unix(objDate);
        this.$store.commit(DiaryListConstants.COMMIT.setCalendarDate, {
          date: objDateTemp,
        });
        this.period = period;
        
        console.log('refreshDataByURL: データ設定完了、fetchData実行中...');
        //fetch data
        this.fetchData();
      }
    },
    
    /**
     * 契約社員認証状態をチェックし、必要に応じて初期化
     */
    checkContractorAuthAndInitialize() {
      // URLパラメータがある場合は既にrefreshDataByURLで処理済み
      const hasUrlParams = this.$route.query.siteId || this.$route.query.objDate || this.$route.query.period;
      if (hasUrlParams) {
        return;
      }
      
      // 契約社員として認証済みの場合、初期化処理を実行
      if (contractorAuthApi.isAuthenticated() && contractorAuthApi.isTokenValid()) {
        console.log('既に契約社員として認証済み - データ取得を開始');
        this.initializeDataAfterAuth();
      }
    },
    
    /**
     * 認証後の初期化処理（契約社員ログイン後）
     */
    async initializeDataAfterAuth() {
      try {
        // サイト一覧を取得
        await this.$store.dispatch(DiaryListConstants.DISPATCH.getSiteRecords);
        
        console.log('サイト一覧取得完了');
        
        // NextTickを使用して、Vuexの状態更新が完全に反映されるまで待つ
        await this.$nextTick();
        
        // サイトが取得できた場合、最初のサイトを選択してデータを取得
        const sites = this.$store.getters[DiaryListConstants.GETTERS.getSites];
        if (sites && sites.length > 0) {
          // 最初のサイトを選択
          const firstSite = sites[0];
          this.$store.commit(DiaryListConstants.COMMIT.setSiteSelected, {
            site: firstSite.id,
          });
          
          // 今日の日付を設定
          const today = moment();
          this.$store.commit(DiaryListConstants.COMMIT.setCalendarDate, {
            date: today,
          });
          
          // デフォルトピリオドを設定
          this.period = 'daytime';
          
          console.log('選択サイト:', firstSite.id, '日付:', today.format('YYYY-MM-DD'));
          
          // もう一度NextTickを待って、すべての状態更新が完了してからデータ取得
          await this.$nextTick();
          
          // データを取得
          this.fetchData();
        } else {
          console.warn('サイト一覧が空です');
        }
      } catch (error) {
        console.error('認証後の初期化でエラーが発生:', error);
      }
    },
    // *********start hook event date time picker
    dtUpdate(date) {
      // カレンダーが開いた直後のdp-updateイベントはスキップする。
      // dtShowで既にdateChooseに基づく正しいデータ取得を開始しているため、
      // dp-updateのviewDateが異なる月（現在の月等）を指す場合に
      // 正しいデータが上書きされるのを防ぐ。
      if (this.calendarJustOpened) {
        return;
      }

      const objDate = moment(date.viewDate._d.toISOString());
      this.$store.dispatch(
        DiaryListConstants.DISPATCH.getDiariesEditingRecords,
        {
          siteId: this.siteSelected,
          month: objDate.format("MM"),
          year: objDate.format("YYYY"),
        }
      );
      setTimeout(() => {
        DiaryListServices.showDateHighLight(
          this.diaryEditingPrevious,
          this.diaryEditingCurrent,
          false,
          true
        );
      }, 1000);
    },
    deleteCo2InputAmount(attr, index, subAttr) {
      const obj = { attr: attr, index: index, subAttr: subAttr };
      this.$store.commit(DiaryListConstants.COMMIT.deleteCo2InputAmount, obj);
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      const siteSelected =
        this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
      putCo2Input(siteSelected, co2Input);
      //reset after deleted
      this.setDeletingObject("", -1, "");
    },
    showConfirmModal(attr, index, subAttr = "") {
      this.$bvModal.show("confirm-modal");
      this.setDeletingObject(attr, index, subAttr);
    },
    setDeletingObject(attr, index, subAttr = "") {
      this.deletingObjectAmount["attr"] = attr;
      this.deletingObjectAmount["index"] = index;
      this.deletingObjectAmount["subAttr"] = subAttr;
    },
    dtChange(date) {
      //remove focus by active element
      document.activeElement.blur();
      //reset clicked and disable
      this.resetData();
      //set date
      this.dateChoose = date.date;

      const currentMMChoose = date.date.format("MM");
      const oldMMChoose = date.oldDate.format("MM");

      if (this.siteSelected != null) {
        if (oldMMChoose != currentMMChoose) {
          this.getDiaryEditing();
        }
        const objDate = this.$route.query.objDate;
        const objDateTemp = moment.unix(objDate);
        //reset period to daytime if current day is different with objDate from URL
        if (objDateTemp.format("DD-MM") != date.date.format("DD-MM")) {
          if (!this.diariesEditingLinkIsClicked) {
            this.handleClickPeriod("daytime");
          }
          this.diariesEditingLinkIsClicked = false;
        } else {
          this.handleClickPeriod(this.period);
          //fetch diaryEditing when copy diary success
          this.getDiaryEditing();
        }
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "co2InSiteWork",
          value: [],
        });
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "co2OutSiteWorkWaste",
          value: [],
        });
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "co2OutSiteWorkContructionSoil",
          value: [],
        });
        this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
          path: "editor",
          value: "",
        });
      }
      setTimeout(() => {
        this.handleDoubleClickActiveDay();
      }, 100);
    },
    handleDoubleClickActiveDay() {
      const element = this.$el.querySelector(
        ".diary-list-date-picker-input-meeting-date td.active"
      );
      if (element) {
        element.addEventListener("click", () => {
          setTimeout(() => {
            DiaryListServices.showDateHighLight(
              this.diaryEditingPrevious,
              this.diaryEditingCurrent,
              false,
              true
            );
            this.handleDoubleClickActiveDay();
          }, 100);
        });
      }
    },
    // *********end hook event datetime picker
    async changeSite() {
      //reset clicked and disable
      this.isCO2InputChanged = false;
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "editor",
        value: null,
      });
      this.resetData();
      this.$store.commit(DiaryListConstants.COMMIT.resetDiaryListStore);
      this.resetDataCO2InsiteSiteWork();
      this.resetDataCO2OutSiteWork();
      if (this.siteSelected != null) {
        await this.getDiaryEditing();
        await this.$store.dispatch(DiaryListConstants.DISPATCH.getCo2Input, {
          siteId: this.siteSelected,
        });
        await this.$store.dispatch(
          DiaryListConstants.DISPATCH.getMetaDataSite,
          { siteId: this.siteSelected }
        );
      }
      this.setSiteName();
      this.updateSiteNameInMetaData();
    },
    setSiteName() {
      //set siteName
      const site =
        this.siteSelected &&
        this.sites.find((site) => {
          return site.id == this.siteSelected;
        });
      const siteName = site ? site.name : "";
      this.$store.commit(DiaryListConstants.COMMIT.updateMetaDataSite, {
        attr: "siteName",
        value: siteName,
      });
    },
    updateSiteNameInMetaData() {
      const metaData = Object.assign({}, this.metaData, {
        workPeriod: {
          endDate: this.workPeriod.endDate,
          startDate: this.workPeriod.startDate,
        },
      });
      putMetaDataSite(this.siteSelected, metaData);
    },
    resetData() {
      this.$store.commit(DiaryListConstants.COMMIT.resetDiaryList);
    },
    handleClickPeriod(period) {
      //set period
      this.resetData();
      this.period = period;
      //call API get Diary detail
      this.getDiaryDetailData();
    },
    getDiaryDetailData() {
      if (this.siteSelected) {
        this.$store.commit(DashboardConstants.COMMIT.resetState);
        this.$store.dispatch(DiaryListConstants.DISPATCH.getDiariesRecords, {
          siteId: this.siteSelected,
          month: this.dateChoose.format("MM"),
          year: this.dateChoose.format("YYYY"),
          day: this.dateChoose.format("DD"),
          period: this.period,
        });
      } else {
        // TODO: handle errors
        // console.log("errors", "siteId clicked");
      }
    },
    getDiaryEditing() {
      this.$store.dispatch(
        DiaryListConstants.DISPATCH.getDiariesEditingRecords,
        {
          siteId: this.siteSelected,
          month: this.dateChoose.format("MM"),
          year: this.dateChoose.format("YYYY"),
        }
      );
    },
    //generate url to dashboard
    //objDate is currently the Date choose in the calendar
    generateLinkDashboard(diaryRevisions, index) {
      const isFirstElement = index == diaryRevisions.length - 1;
      const lastDiaryId = diaryRevisions[index].diaryId;
      const previousDiaryId = isFirstElement
        ? ""
        : diaryRevisions[index + 1].diaryId;
      const metaDataLinkDashboard = this.metaDataLinkDashboard;
      return `/dashboard/?diary=${lastDiaryId}&diaryPrevious=${previousDiaryId}&isLatest=true${metaDataLinkDashboard}`;
    },
    /*
     * diary: is latest diary id
     * diaryPrevious: is previous diary id
     * isLatest: false mean it's latest diary
     * typeEdit: define type edit diary
     * metaDataLinkDashboard: is site id, date time, and period
     */
    generateLinkButton(diaryRevisions, typeEdit) {
      const index = 0;
      const metaDataLinkDashboard = this.metaDataLinkDashboard;
      const lastDiaryId =
        diaryRevisions[index] && diaryRevisions[index].diaryId;
      if (diaryRevisions.length >= 2) {
        const previousDiaryId = diaryRevisions[index + 1].diaryId;
        return `/dashboard/?diary=${lastDiaryId}&diaryPrevious=${previousDiaryId}&isLatest=false&typeEdit=${typeEdit}${metaDataLinkDashboard}`;
      } else if (diaryRevisions.length == 1) {
        return `/dashboard/?diary=${lastDiaryId}&isLatest=false&typeEdit=${typeEdit}${metaDataLinkDashboard}`;
      } else {
        return `/dashboard/?isLatest=false&typeEdit=${typeEdit}${metaDataLinkDashboard}`;
      }
    },
    addAmount(attr) {
      this.$store.commit(DiaryListConstants.COMMIT.addAmountCo2Input, {
        attr: attr,
      });
    },
    formatCo2Input(co2Input) {
      let result = this.$_.cloneDeep(co2Input);
      const objectNeedDelete = [
        "isFocusMonth",
        "isFocusValue",
        "isFocusYear",
        "isFocusCost",
        "isValidateMonth",
        "isValidateValue",
        "isValidateYear",
        "isValidateCost",
      ];
      const attributePathDelete = [
        "installSolarPanelsOnSite.amount.isFocus",
        "installSolarPanelsOnSite.amount.isValidate",
        "installWindPowerGenerationOnSite.usage.isFocus",
        "installWindPowerGenerationOnSite.usage.isValidate",
        "useOfB5.amount.isValidate",
        "useOfB5.amount.isFocus",
        "useOfB100.amount.isValidate",
        "useOfB100.amount.isFocus",
        "useOfCementAlternative.usage.isValidate",
        "useOfCementAlternative.usage.isFocus",
      ];
      const attributeElectricityPathDelete = [
        "utilizationOfElectricityMenus.amount.isFocus",
        "utilizationOfElectricityMenus.amount.isValidate",
      ];

      for (let attributeDelete of objectNeedDelete) {
        for (let indexAmountElectricity in result.electricity.amount) {
          delete result.electricity.amount[indexAmountElectricity][
            attributeDelete
          ];
        }
        for (let indexAmountKerosene in result.kerosene.amount) {
          delete result.kerosene.amount[indexAmountKerosene][attributeDelete];
        }
        for (let indexAmountHeavyOil in result.heavyOil.amount) {
          delete result.heavyOil.amount[indexAmountHeavyOil][attributeDelete];
        }
        for (let indexMonthlyUse in result.electricity
          .utilizationOfElectricityMenus.monthlyUses) {
          delete result.electricity.utilizationOfElectricityMenus.monthlyUses[
            indexMonthlyUse
          ][attributeDelete];
          result.electricity.utilizationOfElectricityMenus.monthlyUses[
            indexMonthlyUse
          ].cost.unit = "JPY";
        }
      }
      result.others.useOfCementAlternative.isUsed =
        result.others.useOfCementAlternative.monthlyUses &&
        result.others.useOfCementAlternative.monthlyUses.length > 0;
      result.electricity = this.$_.omit(
        result.electricity,
        attributeElectricityPathDelete
      );
      result.others = this.$_.omit(result.others, attributePathDelete);
      return result;
    },
    //call api put co2Input
    editCo2Input() {
      const co2Input =
        this.$store.getters[DiaryListConstants.GETTERS.getCo2Input];
      const co2InputAfterFormat = this.formatCo2Input(co2Input);
      putCo2Input(this.siteSelected, co2InputAfterFormat);
    },
    // handle co2Input
    updateStateCo2Input(attr, subAttr, value, index) {
      switch (attr) {
        case "electricity":
          if (subAttr === "utilizationOfElectricityMenus") {
            this.$store.commit(
              DiaryListConstants.COMMIT.updateStateCo2Selection,
              { subAttr: subAttr, value: value }
            );
            //call api put co2Input
            return this.editCo2Input();
          }
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
            { subAttr: subAttr, value: value, index }
          );
          break;
        case "water":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputWater,
            { subAttr: subAttr, value: value }
          );
          break;
        case "kerosene":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputKerosene,
            { subAttr: subAttr, value: value }
          );
          break;
        case "diesel":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputDiesel,
            { subAttr: subAttr, value: value }
          );
          break;
        case "heavyOil":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputHeavyOil,
            { subAttr, value }
          );
          break;
        case "alterNativeFuel":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeFuel,
            { subAttr, index, value }
          );
          break;
        case "alterNativeEnergy":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeEnergy,
            { subAttr, index, value }
          );
          break;
        case "cement":
          this.$store.commit(
            DiaryListConstants.COMMIT.updateStateCo2InputCementAlternative,
            { subAttr, index, value }
          );
          break;

        default:
          break;
      }
      if (
        attr === "electricity" ||
        attr === "kerosene" ||
        attr === "heavyOil" ||
        attr === "waterIntake" ||
        attr === "drainageDestination" ||
        attr === "alterNativeFuel" ||
        attr === "alterNativeEnergy" ||
        attr === "cement"
      ) {
        let isValidate = null;
        console.log("DAATA::", value);
        if (subAttr === "year") {
          isValidate = validateYear(value);
        } else if (subAttr === "month") {
          isValidate = validateMonth(value);
        } else if (subAttr === "amount.value") {
          isValidate = validateValue(value);
        } else if (subAttr === "cost.value") {
          isValidate = validateJPY(value);
        }
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
          {
            attr:
              attr === "electricity" ? "utilizationOfElectricityMenus" : attr,
            subAttr: subAttr,
            index: index,
            isValidate: isValidate,
          }
        );
      }
      //call api put co2Input
      this.editCo2Input();
    },
    updateCo2InputUsed(attr, value) {
      this.$store.commit(DiaryListConstants.COMMIT.setCo2InputOrderUsed, {
        attr: attr,
        value: value,
      });
      //reset value input
      this.$store.commit(DiaryListConstants.COMMIT.updateStateCo2InputOthers, {
        subAttr: attr,
        value: "",
      });
      //call api put co2Input
      this.editCo2Input();
    },
    updateCo2InputAmount(attr, subAttr, index, value) {
      this.$store.commit(DiaryListConstants.COMMIT.updateCo2InputAmount, {
        attr: attr,
        subAttr: subAttr,
        index: index,
        value: value,
      });
      if (
        attr === "electricity" ||
        attr === "kerosene" ||
        attr === "heavyOil" ||
        attr === "waterIntake" ||
        attr === "drainageDestination"
      ) {
        let isValidate = null;
        if (subAttr == "year") {
          isValidate = validateYear(value);
        } else if (subAttr == "month") {
          isValidate = validateMonth(value);
        } else if (subAttr == "value") {
          isValidate = validateValue(value);
        } else if (subAttr == "cost") {
          isValidate = validateJPY(value);
        }
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
          { attr: attr, subAttr: subAttr, index: index, isValidate: isValidate }
        );
      }
    },
    isInt($event) {
      isInt($event);
    },
    isFloat($event) {
      isFloat($event);
    },
    updateStateCo2InputElectricityStore(attributeOther, typeMeasure, value) {
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
        { subAttr: attributeOther, value: value }
      );
      const isValidate = validateValue(value);
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsValidateElectricity,
        {
          attr: attributeOther,
          typeMeasure: typeMeasure,
          isValidate: isValidate,
        }
      );
      this.editCo2Input();
    },
    updateStateCo2InputOthersStore(attributeOther, typeMeasure, value) {
      this.$store.commit(DiaryListConstants.COMMIT.updateStateCo2InputOthers, {
        subAttr: attributeOther,
        value: value,
      });
      const isValidate = validateValue(value);
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsValidateOthers,
        {
          attributeOther: attributeOther,
          typeMeasure: typeMeasure,
          isValidate: isValidate,
        }
      );
    },
    updateStateCo2InputWater(attributeOther, typeMeasure, value) {
      this.$store.commit(DiaryListConstants.COMMIT.updateStateCo2InputWater, {
        subAttr: attributeOther,
        typeMeasure,
        value: value,
      });
      const isValidate = validateValue(value);
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsValidateWater,
        {
          attributeOther: attributeOther,
          typeMeasure: typeMeasure,
          isValidate: isValidate,
        }
      );
      this.editCo2Input();
    },
    updateStateCo2SelectionWater(attributeOther, typeMeasure, value) {
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCo2SelectionWater,
        { subAttr: attributeOther, typeMeasure, value: value }
      );
      this.editCo2Input();
    },
    fetchData() {
      if (this.siteSelected != null) {
        //get co2Input
        this.$store.dispatch(DiaryListConstants.DISPATCH.getCo2Input, {
          siteId: this.siteSelected,
        });
        this.$store.dispatch(DiaryListConstants.DISPATCH.getMetaDataSite, {
          siteId: this.siteSelected,
        });
        //get editing diary
        this.getDiaryEditing();
        //get diary detail
        this.getDiaryDetailData();
      }
    },
    handleClickEditingDiary(diary) {
      this.dateChoose = moment(diary.diaryDate, "YYYY-MM-DD");
      this.period = diary.diaryPeriod;
      this.diariesEditingLinkIsClicked = true;
      //get diary detail
      this.getDiaryDetailData();
    },
    checkDiaryPresent(diaries, diary) {
      if (diaries == undefined || diaries.length == 0) {
        return false;
      }
      for (let i = diaries.length - 1; i >= 0; i--) {
        const conditionDiary =
          moment(diary.diaryDate).format("YYYY-MM-DD") ==
          moment(diaries[i].diaryDate).format("YYYY-MM-DD");
        const conditionPeriod = diary.diaryPeriod == diaries[i].diaryPeriod;
        if (conditionDiary && conditionPeriod) {
          return true;
        }
      }
      return false;
    },
    handleFocusAmount(attr, subAttr, index, isFocus) {
      const obj = {
        attr: attr,
        subAttr: subAttr,
        index: index,
        isFocus: isFocus,
      };
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsFocus,
        obj
      );
      let isValidate = null;
      switch (attr) {
        case "electricity": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputElectricity.amount[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "year", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputElectricity.amount[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "month", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputElectricity.amount[index]["isValidateValue"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "value", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusCost" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputElectricity.amount[index]["isValidateCost"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "cost", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "cost", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "utilizationOfElectricityMenus": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputElectricity.utilizationOfElectricityMenus
                .monthlyUses[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
                { subAttr: "year", value: "", index }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr, subAttr: "year", index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputElectricity.utilizationOfElectricityMenus
                .monthlyUses[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
                { subAttr: "month", value: "", index }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr, subAttr: "month", index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputElectricity.utilizationOfElectricityMenus
                .monthlyUses[index].amount["isValidateValue"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
                { subAttr: "amount.value", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { subAttr: "amount.value", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusCost" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputElectricity.utilizationOfElectricityMenus
                .monthlyUses[index].cost["isValidateCost"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
                { subAttr: "cost.value", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { subAttr: "cost.value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "kerosene": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputKerosene.amount[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "year", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputKerosene.amount[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "month", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputKerosene.amount[index]["isValidateValue"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "value", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusCost" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputKerosene.amount[index]["isValidateCost"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "cost", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "cost", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "heavyOil": {
          if (subAttr == "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputHeavyOil.amount[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "year", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr == "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputHeavyOil.amount[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "month", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr == "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputHeavyOil.amount[index]["isValidateValue"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "value", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusCost" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputHeavyOil.amount[index]["isValidateCost"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "cost", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "cost", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "waterIntake": {
          if (subAttr == "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputWater.waterIntake.amount[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "year", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr == "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputWater.waterIntake.amount[index][
                "isValidateMonth"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "month", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr == "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputWater.waterIntake.amount[index][
                "isValidateValue"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "value", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "drainageDestination": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputWater.drainageDestination.amount[index][
                "isValidateYear"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "year", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputWater.drainageDestination.amount[index][
                "isValidateMonth"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "month", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputWater.drainageDestination.amount[index][
                "isValidateValue"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateCo2InputAmount,
                { attr: attr, subAttr: "value", index: index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "alterNativeFuel": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputAlterNativeFuel[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeFuel,
                { subAttr: "year", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputAlterNativeFuel[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeFuel,
                { subAttr: "month", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputAlterNativeFuel[index].amount["isValidateValue"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeFuel,
                { subAttr: "amount.value", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "alterNativeEnergy": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputAlterNativeEnergy[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeEnergy,
                { subAttr: "year", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputAlterNativeEnergy[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeEnergy,
                { subAttr: "month", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputAlterNativeEnergy[index].amount[
                "isValidateValue"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputAlterNativeEnergy,
                { subAttr: "amount.value", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
        case "cement": {
          if (subAttr === "isFocusYear" && !isFocus) {
            //reset value at index year
            isValidate =
              this.getCo2InputCementAlternative[index]["isValidateYear"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputCementAlternative,
                { subAttr: "year", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "year", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusMonth" && !isFocus) {
            //reset value at index Month
            isValidate =
              this.getCo2InputCementAlternative[index]["isValidateMonth"];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputCementAlternative,
                { subAttr: "month", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "month", index: index, isValidate: true }
              );
            }
          } else if (subAttr === "isFocusValue" && !isFocus) {
            //reset value at index Value
            isValidate =
              this.getCo2InputCementAlternative[index].amount[
                "isValidateValue"
              ];
            if (!isValidate) {
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCo2InputCementAlternative,
                { subAttr: "amount.value", index, value: "" }
              );
              this.$store.commit(
                DiaryListConstants.COMMIT.updateStateCO2InputIsValidate,
                { attr: attr, subAttr: "value", index: index, isValidate: true }
              );
            }
          }
          break;
        }
      }
      if (!isFocus && isValidate) {
        //call api put co2Input
        this.editCo2Input();
      }
    },
    handleFocusElectricity(attributeOther, typeMeasure, isFocus) {
      const obj = {
        attr: attributeOther,
        typeMeasure: typeMeasure,
        isFocus: isFocus,
      };
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsFocusElectricity,
        obj
      );
      //reset value if validate false
      const isValidate =
        this.getCo2InputOrders[attributeOther][typeMeasure]["isValidate"];
      if (!isValidate) {
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCo2InputElectricity,
          { subAttr: attributeOther, value: "" }
        );
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCO2InputIsValidateElectricity,
          {
            attributeOther: attributeOther,
            typeMeasure: typeMeasure,
            isValidate: true,
          }
        );
      } else if (!isFocus) {
        //call api put co2Input
        this.editCo2Input();
      }
    },
    handleFocusOthers(attributeOther, typeMeasure, isFocus) {
      const obj = {
        attributeOther: attributeOther,
        typeMeasure: typeMeasure,
        isFocus: isFocus,
      };
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsFocusOthers,
        obj
      );
      //reset value if validate false
      const isValidate =
        this.getCo2InputOrders[attributeOther][typeMeasure]["isValidate"];
      if (!isValidate) {
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCo2InputOthers,
          { subAttr: attributeOther, value: "" }
        );
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCO2InputIsValidateOthers,
          {
            attributeOther: attributeOther,
            typeMeasure: typeMeasure,
            isValidate: true,
          }
        );
      } else if (!isFocus) {
        //call api put co2Input
        this.editCo2Input();
      }
    },
    handleFocusWater(attributeOther, typeMeasure, isFocus) {
      const obj = {
        attributeOther: attributeOther,
        typeMeasure: typeMeasure,
        isFocus: isFocus,
      };
      this.$store.commit(
        DiaryListConstants.COMMIT.updateStateCO2InputIsFocusWater,
        obj
      );
      //reset value if validate false
      const isValidate =
        this.getCo2InputWater[attributeOther][typeMeasure]["isValidate"];
      if (!isValidate) {
        this.$store.commit(DiaryListConstants.COMMIT.updateStateCo2InputWater, {
          subAttr: attributeOther,
          value: "",
        });
        this.$store.commit(
          DiaryListConstants.COMMIT.updateStateCO2InputIsValidateWater,
          {
            attributeOther: attributeOther,
            typeMeasure: typeMeasure,
            isValidate: true,
          }
        );
      } else if (!isFocus) {
        //call api put co2Input
        this.editCo2Input();
      }
    },
    copyDiary() {
      console.log("🚀 DiaryList: copyDiary() メソッド開始");
      this.$bvModal.show("copy-diary-modal");
      this.$store.dispatch(DiaryListConstants.DISPATCH.getDiaryDetail);
      console.log("🚀 DiaryList: copy-diary-modal表示とgetDiaryDetail実行完了");
    },
    openKySheet() {
      const siteId = this.siteSelected;
      
      if (!siteId) {
        console.error('Missing siteId for KY Excel generation');
        return;
      }

      // 現在選択されている日付と期間を取得
      const diaryDate = this.dateChoose ? this.dateChoose.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
      const diaryPeriod = this.period || "daytime";

      console.log('KY Excel generation parameters:', { siteId, diaryDate, diaryPeriod });

      // Generate KY Excel using the backend API
      generateKyExcel(siteId, diaryDate, diaryPeriod)
        .then((response) => {
          console.log('KY Excel generated successfully:', response);
          
          // Get the Excel data and filename from response
          const { excelData, fileName } = response.data;
          
          if (excelData && fileName) {
            // Convert Base64 to Blob
            const byteCharacters = atob(excelData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });

            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } else {
            console.error('Excel data or filename not received from server');
          }
        })
        .catch((error) => {
          console.error('Failed to generate KY Excel:', error);
        });
    },
    getValueInSiteWorkAt(index) {
      return this.co2InSiteWork[index];
    },
    addNewLineInSiteWork() {
      this.$store.commit(
        DashboardConstants.COMMIT.addNewRecord,
        "co2InSiteWork"
      );
    },
    resetDataInSiteWork(attr, index) {
      const path = ["co2InSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: "",
      });
    },
    resetDataCO2InsiteSiteWork() {
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "co2InSiteWork",
        value: [],
      });
    },
    resetDataCO2OutSiteWork() {
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "co2OutSiteWorkWaste",
        value: [],
      });
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: "co2OutSiteWorkContructionSoil",
        value: [],
      });
    },
    setInputCo2InSiteWork(attr, value, index) {
      // add value machineOwner
      this.isCO2InputChanged = true;
      const path = ["co2InSiteWork", index, attr].join(".");
      let obj_input = { path: path, value: value };
      // this.isCO2InputChanged = true;
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, obj_input);
    },
    addClassHeaderInSiteWork(index) {
      if (index == 3) {
        return "in-site-work-th-number";
      } else if (index == 5) {
        return "in-site-work-th-total-operation-time";
      }
    },
    getHeaderColspan(index) {
      return index < 1 || index == 4 ? 2 : 1;
    },
    addAlterNativeFuel() {
      const obj = {
        type: "",
        year: "",
        month: "",
        isValidateYear: true,
        isValidateMonth: true,
        amount: {
          isValidateValue: true,
          value: "",
          unit: "L",
        },
      };
      this.$store.commit(DiaryListConstants.COMMIT.AddAlterNativeFuel, obj);
      //Request PUT data
      this.editCo2Input();
    },
    addAlterNativeEnergy() {
      const obj = {
        type: "",
        year: "",
        month: "",
        isValidateYear: true,
        isValidateMonth: true,
        amount: {
          isValidateValue: true,
          value: "",
          unit: "kW",
        },
      };
      this.$store.commit(DiaryListConstants.COMMIT.AddAlterNativeEnergy, obj);
      //Request PUT data
      this.editCo2Input();
    },
    addElectricity() {
      const obj = {
        year: "",
        month: "",
        amount: {
          value: "",
          unit: "kWh",
          isValidateValue: true,
        },
        cost: {
          value: "",
          unit: "JPY",
          isValidateCost: true,
        },
        isValidateYear: true,
        isValidateMonth: true,
      };
      this.$store.commit(DiaryListConstants.COMMIT.addElectricity, obj);
      //Request PUT data
      this.editCo2Input();
    },
    addCement() {
      const obj = {
        year: "",
        month: "",
        isValidateYear: true,
        isValidateMonth: true,
        amount: {
          isValidateValue: true,
          value: "",
          unit: "㎥",
        },
      };
      this.$store.commit(DiaryListConstants.COMMIT.addCementAlterNative, obj);
      //Request PUT data
      this.editCo2Input();
    },
    addNewLineOutSiteWork() {
      this.$store.commit(
        DashboardConstants.COMMIT.addNewRecord,
        "co2OutSiteWork"
      );
    },
    addNewLineOutSiteWorkWaste() {
      this.$store.commit(
        DashboardConstants.COMMIT.addNewRecord,
        "co2OutSiteWorkWaste"
      );
    },
    addNewLineOutSiteWorkContructionSoil() {
      this.$store.commit(
        DashboardConstants.COMMIT.addNewRecord,
        "co2OutSiteWorkContructionSoil"
      );
    },
    getLayerName(
      oldMachineFirstLayer,
      oldMachineSecondLayer,
      oldMachineThirdLayer
    ) {
      const machine = DiaryListInternalData.oldMachines.find(
        (machine) =>
          machine.layers["oldMachineFirstLayer"] === oldMachineFirstLayer &&
          machine.layers["oldMachineSecondLayer"] === oldMachineSecondLayer &&
          machine.layers["oldMachineThirdLayer"] === oldMachineThirdLayer
      );
      return machine ? machine.label : "";
    },
    isNewStyle(
      oldMachineFirstLayer,
      oldMachineSecondLayer,
      oldMachineThirdLayer
    ) {
      if (!oldMachineFirstLayer) return true;
      const machine = DiaryListInternalData.oldMachines.find(
        (machine) =>
          machine.layers["oldMachineFirstLayer"] === oldMachineFirstLayer &&
          machine.layers["oldMachineSecondLayer"] === oldMachineSecondLayer &&
          machine.layers["oldMachineThirdLayer"] === oldMachineThirdLayer
      );
      return !!machine;
    },
    getNameFirstLayer(key) {
      return key != "" && Co2Items.CO2_ITEMS[key]
        ? Co2Items.CO2_ITEMS[key].name
        : "";
    },
    getSecondLayer(keyFirstItem) {
      const firstLayer = this.firstMachineLayer;
      for (let firstItem of firstLayer) {
        if (firstItem.key == keyFirstItem) {
          return firstItem.items;
        }
      }
      return firstLayer[1].items;
    },
    getNameSecondLayer(itemFirstLayer, key) {
      let co2Items = Co2Items.CO2_ITEMS;
      if (!co2Items[itemFirstLayer]) {
        return "";
      }
      return itemFirstLayer != "" && key != ""
        ? co2Items[itemFirstLayer].items[key].name
        : "";
    },
    disableSecondLayer(valueFirstLayer) {
      return this.statusEditable || valueFirstLayer == "";
    },
    getThirdLayer(keyFirstItem, keySecondItem) {
      const secondLayer = this.getSecondLayer(keyFirstItem);
      for (let secondItem of secondLayer) {
        if (secondItem.key == keySecondItem) {
          return secondItem.items;
        }
      }
      return secondLayer.items;
    },
    getNameThirdLayer(keyFirstItem, keySecondItem, keyThirdItem) {
      let items = Co2Items.CO2_ITEMS;
      if (!items[keyFirstItem] || !items[keyFirstItem].items[keySecondItem]) {
        return "";
      }
      if (keyFirstItem != "" && keySecondItem != "" && keyThirdItem != "") {
        return items[keyFirstItem].items[keySecondItem].items[keyThirdItem]
          .name;
      }
      return "";
    },
    disableThirdLayer(index) {
      const valueSecondLayer =
        this.getValueInSiteWorkAt(index).oldMachineSecondLayer == null;
      const valueThirdLayer =
        this.getValueInSiteWorkAt(index).oldMachineSecondLayer == "";
      return this.statusEditable || valueSecondLayer || valueThirdLayer;
    },
    setInputCo2OutSiteWork(attr, value, index) {
      const path = ["co2OutSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: value,
      });
    },
    setInputCo2OutSiteWorkWaste(attr, value, index) {
      this.isCO2InputChanged = true;
      const machineTypePath = [
        "co2OutSiteWorkWaste",
        index,
        "machineType",
      ].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: machineTypePath,
        value: DashboardInternalConstant.co2Modal.machineTypeOption[0].key,
      });
      const path = ["co2OutSiteWorkWaste", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: value,
      });
    },
    setInputCo2OutSiteWorkContructionSoil(attr, value, index) {
      this.isCO2InputChanged = true;
      const machineTypePath = [
        "co2OutSiteWorkContructionSoil",
        index,
        "machineType",
      ].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: machineTypePath,
        value: DashboardInternalConstant.co2Modal.machineTypeOption[1].key,
      });
      const path = ["co2OutSiteWorkContructionSoil", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: value,
      });
    },
    existErrors() {
      return this.errors.all().length != 0;
    },
    resetDataOutSiteWork(index, attr) {
      const path = ["co2OutSiteWork", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: "",
      });
    },
    resetDataCo2OutSiteWorkWaste(index, attr) {
      const path = ["co2OutSiteWorkWaste", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: "",
      });
    },
    resetDataCo2OutSiteWorkContructionSoil(index, attr) {
      const path = ["co2OutSiteWorkContructionSoil", index, attr].join(".");
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: "",
      });
    },
    handleOutFocusInSiteWork(attr, index) {
      this.existErrors() && this.resetDataInSiteWork(attr, index);
    },
    handleOutFocusOutSiteWork(attr, index) {
      this.existErrors() && this.resetDataOutSiteWork(index, attr);
    },
    handleOutFocusOutSiteWorkWaste(attr, index) {
      this.existErrors() && this.resetDataCo2OutSiteWorkWaste(index, attr);
    },
    handleOutFocusOutSiteWorkContructionSoil(attr, index) {
      this.existErrors() &&
        this.resetDataCo2OutSiteWorkContructionSoil(index, attr);
    },
    setMachineLayerCo2Input(index, attr, value) {
      this.isCO2InputChanged = true;
      if (Co2ModalHelper.validateMachineLayer(attr)) {
        this.resetDataMachineLayer(attr, index);
        const objectInput = Co2ModalHelper.generateCo2InputObject(
          index,
          attr,
          value.key
        );
        this.$store.commit(
          DashboardConstants.COMMIT.setValueRecord,
          objectInput
        );
      }
    },
    setMachineLayerInput(index, value) {
      console.log({ index, value });
      const layers = [
        "oldMachineFirstLayer",
        "oldMachineSecondLayer",
        "oldMachineThirdLayer",
      ];
      const machine = this.oldMachineLayers.find(
        (layer) => layer.label === value
      );
      console.log("machine", machine);
      layers.forEach((layer) => {
        const objectInput = Co2ModalHelper.generateCo2InputObject(
          index,
          layer,
          machine.layers[layer]
        );
        this.$store.commit(
          DashboardConstants.COMMIT.setValueRecord,
          objectInput
        );
      });
    },
    resetDataMachineLayer(attr, index) {
      if (attr == "oldMachineFirstLayer") {
        this.resetMachineLayerSecondAndThird(index);
      } else if (attr == "oldMachineSecondLayer") {
        this.resetMachineLayerThird(index);
      }
    },
    resetMachineLayerSecondAndThird(index) {
      this.resetDataInSiteWork("oldMachineSecondLayer", index);
      this.resetDataInSiteWork("oldMachineThirdLayer", index);
    },
    resetMachineLayerThird(index) {
      this.resetDataInSiteWork("oldMachineThirdLayer", index);
    },
    showCO2ConfirmModal(attr, orderId) {
      this.$bvModal.show("confirm-modal");
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, {
        attr: attr,
        orderId: orderId,
      });
    },
    setTimeCo2Input(index, attr, value) {
      const formatValue = value.date ? value.date : null;
      const objectInput = Co2ModalHelper.generateCo2InputObject(
        index,
        attr,
        formatValue
      );
      if (Co2ModalHelper.validateInputTime(attr, value.date)) {
        const defaultStartDate = moment("01/01/2000", "DD/MM/YYYY");
        defaultStartDate.set("hour", value.date.format("HH"));
        defaultStartDate.set("minute", value.date.format("mm"));
        objectInput.value = defaultStartDate.toISOString(true);
      }
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, objectInput);
    },
    get(attr) {
      const value = this.metaData ? this.$_.get(this.metaData, attr, "") : "";
      const isKendoType = attr == "totalFloorArea.value";
      if (isKendoType) {
        const kendoType = this.$_.get(this.metaData, "kendoType", "");
        this.isArchitecture = kendoType === "architecture";
        const isKendoTyeCivilEngineering = kendoType == "civilEngineering";
        return isKendoTyeCivilEngineering ? "" : value;
      }
      const isUseDiary = attr == "use_diary";
      if (isUseDiary) {
        const value =
          _.isNil(value) || (!_.isBoolean(value) && value.length == 0)
            ? true
            : value;
        return value;
      }
      return value;
    },
    changeStateValidateEditor(value) {
      this.validateEditor = value.length != 0;
    },
    saveDiary() {
      this.isPostedDiary = true;
      const siteId = this.siteSelected;
      const typeEdit = this.$route.query.typeEdit;
      const objDateTemp = {
        year: this.dateChoose.format("YYYY"),
        month: this.dateChoose.format("MM"),
        day: this.dateChoose.format("DD"),
      };

      let diaryTemp =
        this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions];
      // validate
      const objValidate = this.validateDiary(diaryTemp);
      if (objValidate.status) {
        diaryTemp.diaryDate = `${objDateTemp.year}-${objDateTemp.month}-${objDateTemp.day}`;
        let diary = DashboardServices.serializerDiary(
          diaryTemp,
          siteId,
          typeEdit,
          true
        );
        // API送信用にworkRecordsを元の形式に変換
        const apiDiary = ShowRevisionServices.prepareDiaryForApi(diary);
        console.log("🔧 DiaryList - API送信前のdiary変換:", { 
          original: diary.workRecords, 
          converted: apiDiary.workRecords 
        });
        
        postDiaryApi(apiDiary).then((response) => {
          this.statusSaveDiary = response.data.success;
          this.$bvModal.show("bv-modal-mess");
          this.getDiaryDetailData();
        }).catch((error) => {
          console.error("日誌の保存に失敗しました:", error);
          this.statusSaveDiary = false;
          this.$bvModal.show("bv-modal-mess");
        });
        this.isPostedDiary = false;
        this.isCO2InputChanged = false;
        this.statusEditable = true;
      } else if (objValidate.mess == "meetingDateTimeNotNull") {
        this.statusSaveDiary = false;
        this.isPostedDiary = false;
        this.$bvModal.show("bv-modal-mess");
      } else if (objValidate.mess == "editorRequired") {
        this.showEditorError = true;
        this.isPostedDiary = false;
      }
    },
    validateDiary(diary) {
      //editor is null
      if (diary.editor == "") {
        return { status: false, mess: "editorRequired" };
      } else if (diary.meetingDateTime == undefined) {
        return { status: false, mess: "meetingDateTimeNotNull" };
      }
      return { status: true, mess: "" };
    },
    setDataHeader(path, value) {
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, {
        path: path,
        value: value,
      });
      this.isCO2InputChanged = path == "editor" && value != "";
      path == "editor" && value != "" && (this.showEditorError = false);
    },
    dtShow() {
      this.calendarJustOpened = true;
      this.getDiaryEditing();
      setTimeout(() => {
        this.calendarJustOpened = false;
        DiaryListServices.showDateHighLight(
          this.diaryEditingPrevious,
          this.diaryEditingCurrent,
          false,
          true
        );
      }, 100);
    },
    dtHide(date) {
      this.calendarJustOpened = false;
      const objDate = moment(date.date);
      this.dateChoose = objDate;
      this.resetData();
      this.handleClickPeriod(this.period);
      this.getDiaryEditing();
    },
    handleBackButton() {
      let isLatest = this.$route.query.isLatest;
      this.$store.commit(
        DashboardConstants.COMMIT.setStatusEditable,
        isLatest == "true"
      );
    },
  },
  
  beforeDestroy() {
    // イベントリスナーのクリーンアップ
    this.$root.$off('contractor-auth-changed');
  },
  filters: {
    fomatLLWeekday(date, locale) {
      //2020年12月24日 木 日中
      let loca = locale;
      if (locale === "jp") {
        loca = "ja";
      }
      return moment(date).locale(loca).format("LL dddd");
    },
    fomatLLLLWeekday(date, locale) {
      // 2021年4月14日 水曜日 11:51
      if (!date) return "日付なし";

      try {
        let loca = locale;
        if (locale === "jp") {
          loca = "ja";
        }

        // 日付文字列からタイムゾーン情報[Asia/Tokyo]を削除
        let dateStr = date;
        if (typeof date === "string") {
          dateStr = date.replace(/\[.*\]/, "");
        }

        const momentDate = moment(dateStr);
        if (!momentDate.isValid()) {
          console.error("Invalid date format:", date);
          return "無効な日付";
        }

        return momentDate.locale(loca).format("LLLL");
      } catch (e) {
        console.error("Error formatting date:", date, e);
        return "日付エラー";
      }
    },
    formatMMHH(dt) {
      return moment(dt).format("HH:mm");
    },
    getDiffDay(actual_dt, unit) {
      const millisecondIn24Hours = 24 * 1000 * 60 * 60;
      if (!Co2ModalHelper.validateDifferentActualTime(actual_dt, unit)) {
        return !!actual_dt.to && !!actual_dt.from ? "00:00" : "-";
      }
      if (!actual_dt.to || !actual_dt.from) {
        return "-";
      }
      let diff_time_actual = moment(actual_dt.to).diff(moment(actual_dt.from));
      if (diff_time_actual < 0) {
        diff_time_actual = millisecondIn24Hours + diff_time_actual;
      }
      diff_time_actual *= unit;
      let hours = parseInt(diff_time_actual / 1000 / 60 / 60);
      let minutes = parseInt((diff_time_actual / 1000 / 60) % 60);
      if (hours <= 9) {
        hours = "0" + hours;
      }
      if (minutes <= 9) {
        minutes = "0" + minutes;
      }
      return `${hours}:${minutes}`;
    },
  },
  watch: {
    diaries: async function (newDiaries, oldDiaries) {
      this.diaryEditingCurrent = newDiaries;
      this.diaryEditingPrevious = oldDiaries;
      DiaryListServices.showDateHighLight(oldDiaries, newDiaries);
    },
    diaryRevisions: async function () {
      if (this.diaryRevisions.length > 0) {
        const lastDiary = this.diaryRevisions[0];
        console.log(`lastDiary.revision`, lastDiary.revision);
        const objDateTime = moment(lastDiary.diaryDate);
        const objDate = {
          year: objDateTime.format("YYYY"),
          month: objDateTime.format("MM"),
          day: objDateTime.format("DD"),
        };
        console.info("objDate on diaryList", objDate);
        await this.$store.dispatch(
          DashboardConstants.DISPATCH.getDiaryRevisionRecords,
          {
            siteId: this.siteSelected,
            objDate: objDate,
            diaryId: lastDiary.diaryId,
            diaryIdPrevious: null,
            typeEdit: lastDiary.editAs,
            period: lastDiary.diaryPeriod,
          }
        );
      }
    },
  },
};
